
















































































































































































































































































































































































































































































































import axios from 'axios';
import { clone, cloneDeep, get, uniq } from 'lodash';
import EventBus from '@/eventBus';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoImage from '@/components/Atoms/co-image/CoImage.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoTextArea from '@/components/Molecules/co-TextArea/CoTextArea.vue';
import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoMultiSelect from '@/components/Molecules/co-multiselect/CoMultiSelect.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoDragDropFileUpload from '../co-drag-drop-file-upload/CoDragDropFileUpload.vue';
import CoModal from '../co-modal/CoModal.vue';
import CoTagList from '../co-TagList/coTagList.vue';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';
import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';

export default {
    name: 'CoUserProfileEditor',
    i18n: {
        messages: {
            en: {
                infoaboutme: 'Example: "I like talking about the big questions in life. Also: Yoga and great food!"',
                infoheadline: 'Will be displayed under your name on posts and comments. Keep it short.',
                infopublish: 'Feature my profile publicly on the Hafven website',
                infotags: 'Examples for strong tags: {strongtags}',
                errors: {
                    emailtaken: 'This email already already used by another user.',
                    unabletocheckemail: 'Unable to verify email availability. Please try again.',
                },
            },
            de: {
                infoaboutme:
                    'Beispiel: "Ich unterhalte mich gerne über die großen Fragen des Lebens. Außerdem: Yoga und gutes Essen!"',
                infoheadline: 'Wird unter deinem Namen in allen Posts und Kommentaren angezeigt. Halte dich kurz.',
                infopublish: 'Veröffentliche mein Profil auf der Hafven-Website',
                infotags: 'Beispiel für starke Tags: {strongtags}',
                errors: {
                    emailtaken: 'Diese E-Mail wird bereits von einem anderen Benutzer verwendet.',
                    unabletocheckemail:
                        'Die E-Mail-Verfügbarkeit konnte nicht überprüft werden. Bitte versuche es erneut.',
                },
            },
        },
    },
    components: {
        CoModal,
        CoButton,
        CoInput,
        CoFormGroup,
        CoDragDropFileUpload,
        CoThumbnail,
        CoText,
        CoTextArea,
        CoTagList,
        CoSelect,
        CoMultiSelect,
        CoCheckbox,
        CoSwitch,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        editAs: {
            type: String,
            required: true,
            default: 'user',
            validator: (value: string) => ['user', 'admin', 'moderator'].includes(value),
        },
    },
    emits: ['update', 'cancel'],
    data() {
        return {
            editableUser: { ...this.user },
            candidateImage: null,
            loading: false,
            fields: [],
            uploadingImage: false,
            emailValidation: {
                checking: false,
                debounceTimeout: null,
                pendingEmail: null,
                cache: {},
                invalid: {},
                message: null,
            },

            genderOptions: [
                {
                    Value: 'x',
                    Name: this.$t('labels.nonbinary'),
                },
                { Value: 'f', Name: this.$t('labels.female') },
                { Value: 'm', Name: this.$t('labels.male') },
                { Value: 'u', Name: this.$t('labels.prefernottosay') },
            ],
        };
    },

    computed: {
        fieldsVisabilityInfo() {
            return {
                admin: {
                    icon: 'lock',
                    label:
                        this.editAs === 'admin'
                            ? this.$t('labels.cf.visibilityLevelsFromAdminPOV.admin')
                            : this.$t('labels.cf.visibilityLevelsFromUserPOV.admin'),
                },
                owner: {
                    icon: this.editAs === 'admin' ? 'person' : 'lock',
                    label:
                        this.editAs === 'admin'
                            ? this.$t('labels.cf.visibilityLevelsFromAdminPOV.owner')
                            : this.$t('labels.cf.visibilityLevelsFromUserPOV.owner'),
                },
                community: {
                    icon: 'people',
                    label:
                        this.editAs === 'admin'
                            ? this.$t('labels.cf.visibilityLevelsFromAdminPOV.community')
                            : this.$t('labels.cf.visibilityLevelsFromUserPOV.community'),
                },
            };
        },
        gender() {
            const v = this.editableUser.Profile.Salutation;
            const filtered = this.genderOptions.find((option) => option.Value === v);
            if (filtered) {
                return filtered;
            }
            return { Value: 'u', Name: this.$t('labels.prefernottosay') };
        },
        isChanged() {
            return JSON.stringify(this.user) !== JSON.stringify(this.editableUser) || this.candidateImage;
        },
        canISave() {
            if (this.loading || this.uploadingImage) {
                return false;
            }

            if (this.editAs === 'admin') {
                // email must be valid and available
                const emailValid = this.isValidEmailAndAvailable(this.editableUser.Email);
                if (!emailValid) {
                    return false;
                }

                // first and last name required
                if (!(this.editableUser.Profile.FirstName && this.editableUser.Profile.LastName)) {
                    return false;
                }
            }

            const allLinksValid = this.customFields.every((field) => {
                if (field.InputType === 'link') {
                    return this.isValidLink(field.Value);
                }
                return true;
            });
            if (!allLinksValid) {
                return false;
            }

            return true;
        },
        customFields() {
            const fields = [...(this.editableUser.Fields || [])];

            // stable sort by field sort-order and then by name
            return fields.sort((a, b) => {
                if (a.SortOrder === b.SortOrder) {
                    return a.Label.localeCompare(b.Label);
                }
                return a.SortOrder - b.SortOrder;
            });
        },
    },
    watch: {
        user: {
            handler(newVal) {
                this.editableUser = cloneDeep(newVal);
                this.resetEmailValidationState();
            },
            deep: true,
        },
        'editableUser.Email'(newVal) {
            const trimmed = (newVal || '').trim().toLowerCase();
            const original = (this.user?.Email || '').trim().toLowerCase();
            if (!trimmed || trimmed === original) {
                this.resetEmailValidationState();
            }
        },
    },
    mounted() {
        this.editableUser = cloneDeep(this.user);
        this.resetEmailValidationState();
    },
    beforeDestroy() {
        this.clearEmailValidationTimer();
    },
    methods: {
        isValidLink(value) {
            if (!value) {
                return true;
            }

            return isURL(value);
        },
        genderChanged(selected) {
            if (selected && selected.Value) {
                this.editableUser.Profile.Salutation = selected.Value;
            } else {
                this.editableUser.Profile.Salutation = 'u';
            }
        },
        isValidEmailAndAvailable(email) {
            const sanitizedEmail = typeof email === 'string' ? email.trim() : '';

            if (!sanitizedEmail) {
                this.emailValidation.message = null;
                this.clearEmailValidationTimer();
                return false;
            }

            if (!isEmail(sanitizedEmail)) {
                this.emailValidation.message = this.$t('errors.mustBeValidEmail');
                this.clearEmailValidationTimer();
                return false;
            }

            const normalizedEmail = sanitizedEmail.toLowerCase();
            const originalEmail = (this.user?.Email || '').trim().toLowerCase();

            if (normalizedEmail === originalEmail) {
                this.emailValidation.message = null;
                this.clearEmailValidationTimer();
                return true;
            }

            const invalidMessage = this.emailValidation.invalid[normalizedEmail];
            if (invalidMessage) {
                this.emailValidation.message = invalidMessage;
                return false;
            }

            if (this.emailValidation.cache[normalizedEmail]) {
                this.emailValidation.message = null;
                return true;
            }

            this.emailValidation.message = null;
            this.scheduleEmailAvailabilityCheck(sanitizedEmail, normalizedEmail);

            return true;
        },
        scheduleEmailAvailabilityCheck(email: string, normalizedEmail: string) {
            this.clearEmailValidationTimer();
            this.emailValidation.debounceTimeout = window.setTimeout(() => {
                this.emailValidation.debounceTimeout = null;
                this.checkEmailAvailability(email, normalizedEmail);
            }, 400);
        },
        clearEmailValidationTimer() {
            if (this.emailValidation.debounceTimeout) {
                clearTimeout(this.emailValidation.debounceTimeout);
                this.emailValidation.debounceTimeout = null;
            }
        },
        resetEmailValidationState() {
            this.clearEmailValidationTimer();
            this.emailValidation.checking = false;
            this.emailValidation.pendingEmail = null;
            this.emailValidation.cache = {};
            this.emailValidation.invalid = {};
            this.emailValidation.message = null;
        },
        checkEmailAvailability(email: string, normalizedEmail: string) {
            if (!email) {
                return;
            }

            if (this.emailValidation.pendingEmail === normalizedEmail && this.emailValidation.checking) {
                return;
            }

            this.emailValidation.pendingEmail = normalizedEmail;
            this.emailValidation.checking = true;

            axios
                .post('/user/check-user-with-email', { Email: email })
                .then(() => {
                    this.$set(this.emailValidation.cache, normalizedEmail, true);
                    if (this.emailValidation.invalid[normalizedEmail]) {
                        this.$delete(this.emailValidation.invalid, normalizedEmail);
                    }
                    this.emailValidation.message = null;
                })
                .catch((error) => {
                    let validationMessage = this.$t('errors.unabletocheckemail');

                    if (error?.response?.status === 409 || error?.response?.data?.includes?.('AlreadyExists')) {
                        validationMessage = this.$t('errors.emailtaken');
                    } else {
                        console.error('Error checking email availability', error);
                    }

                    this.$delete(this.emailValidation.cache, normalizedEmail);
                    this.$set(this.emailValidation.invalid, normalizedEmail, validationMessage);
                    this.emailValidation.message = validationMessage;
                })
                .finally(() => {
                    this.emailValidation.checking = false;
                    this.emailValidation.pendingEmail = null;

                    if ((this.editableUser.Email || '').trim().toLowerCase() === normalizedEmail) {
                        this.$nextTick(() => {
                            this.$refs.emailInput?.inputValidation(this.editableUser.Email);
                        });
                    }
                });
        },
        show() {
            this.$refs.userprofileeditmodal.show();
        },
        hide() {
            this.$refs.userprofileeditmodal.hide();
        },
        deleteImage() {
            this.editableUser.Profile.ImageURL = '';
            this.candidateImage = null;
        },
        handleFileSelect(file: any) {
            this.candidateImage = file;
            this.uploadProfileImage();
        },
        uploadProfileImage() {
            if (!this.candidateImage) {
                return;
            }

            const fileToUpload = this.candidateImage.file || this.candidateImage;
            if (!(fileToUpload instanceof Blob)) {
                console.warn('Invalid file provided for profile image upload', fileToUpload);
                return;
            }

            // set file preview
            this.uploadingImage = true;
            this.url = URL.createObjectURL(fileToUpload);
            this.$store
                .dispatch('imageUpload', {
                    file: fileToUpload,
                    url: '/upload/image/user-profile-image',
                })
                .then((response) => {
                    // set new image to profile
                    this.editableUser.Profile.ImageURL = response;
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('errors.uploadfailed'),
                        Details: error.response.data,
                    };
                    if (error.status && error.status === 413) {
                        message.Message = this.$t('errors.filetoolarge', { size: 10 });
                    } else if (error.status && error.status === 424) {
                        message.Message = this.$t('errors.uploadfailed');
                    }
                    EventBus.$emit('ERROR', message);
                })
                .finally(() => {
                    this.uploadingImage = false;
                });
        },

        saveChanges() {
            this.loading = true;

            // conver all Fields values to string
            this.editableUser.Fields = (this.editableUser.Fields || []).map((f) => {
                const field = clone(f);
                if (field.Value === null || field.Value === undefined) {
                    field.Value = '';
                } else if (typeof field.Value !== 'string') {
                    field.Value = String(field.Value);
                } else if (typeof field.Value === 'boolean') {
                    field.Value = field.Value ? 'true' : 'false';
                }
                return field;
            });

            if (this.editAs === 'user') {
                this.saveAsUser();
            } else if (this.editAs === 'admin' || this.editAs === 'moderator') {
                this.saveAsAdmin();
            }
        },

        saveAsUser() {
            this.$store
                .dispatch('updateUser', this.editableUser)
                .then((response) => {
                    const message = {
                        Message: this.$t('labels.changessaved'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    this.$emit('updated', response);
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('labels.failedToSaveChanges'),
                        Details: error.response.data,
                    };
                    EventBus.$emit('ERROR', message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        saveAsAdmin() {
            axios
                .put('/admin/community/member/v2/', this.editableUser)
                .then((response) => {
                    const message = {
                        Message: this.$t('labels.changessaved'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    this.$emit('updated', response);
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('labels.failedToSaveChanges'),
                        Details: error.response.data,
                    };
                    EventBus.$emit('ERROR', message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        tagsChanged(tags) {
            const tmp = uniq(tags);
            this.editableUser.Profile.Tags = tmp;
        },
    },
};
